/**
 * The two halves a `Programme` is selected in. See `src/platform/AGENTS.md`.
 *
 * Kept free of imports: the E2E fixtures load this under Bun, where pulling in
 * Apollo's CommonJS `graphql-tag` races `graphql`'s ESM evaluation.
 *
 * @module platform/programme-selections
 */

export const PROGRAMME_SUMMARY_SELECTION = `id tenantId title awardType nfqLevel totalCredits discipline programmeCode moduleCount workflowState deliveryStatus endOfLife visibilityState saveRevision updatedAt createdBy leadUserId leadUserName leadLastOpenedAt assignedModuleBuilderCount finalSignOffCapacities`;

/** @see PROGRAMME_SUMMARY_SELECTION */
export const PROGRAMME_RECORD_SELECTION = `id tenantId visibilityState workflowState deliveryStatus endOfLife archivedFrom createdBy saveRevision canEdit moduleBaseHashes revisionOf snapshotOf createdAt updatedAt structured`;
